module.exports = __webpack_public_path__ + "img/Number=51.be70196a.png";